/* eslint-disable max-lines */
import { join, capitalize } from "lodash"
import {
  PropertyDetailsURL,
  PropertySearchURL,
  defaultArea,
  defaultAreaNewhomes,
  currency,
  SearchType,
  siteName,
} from "../constant"
import { toCapitalize, getPriceStr } from "./site_utlis"

const METER_VAL = 1609.34

export const meterToMiles = (val) => {
  return Math.round(parseInt(val, 10) / METER_VAL)
}

export const milesToMeter = (val) => {
  return Math.round(parseInt(val, 10) * METER_VAL)
}

export const getLatLan = (item) => {
  if (item?.latitude && item?.longitude) {
    return `${item.latitude},${item.longitude}`
  }
  return ""
}

export const propertyDetailUrl = (
  department,
  search_type,
  status,
  slug,
  id,
) => {
  const prop_slug_id = `${slug}-${id}/`
  const property_url =
    PropertyDetailsURL[department][search_type] + prop_slug_id
  return property_url
}

export const PropertySearchUrl = (department, search_type) => {
  const property_url = PropertySearchURL[department][search_type]
  return property_url
}

export const GetPrice = (price) => {
  let price_format = `${currency}0`
  if (parseInt(price, 10) > 0) {
    price_format = `${currency}${parseInt(price, 10).toLocaleString()}`
  }

  return price_format
}

/** Property Intro */
export const propertyIntro = (
  {
    searchtypeVal,
    buildingval,
    areaVal,
    minpriceVal,
    maxpriceVal,
    bedVal,
    introCopy = false,
    // isMetaTitle = false,
    mustInclude,
    furnishing,
    departmentVal,
    bedValPlus,
    radiusVal,
  },
  propertyTypeList,
) => {
  // console.log("searchtypeVal ==>", searchtypeVal, SearchType[searchtypeVal])

  let areasVal =
    areaVal !== defaultArea.toLowerCase() ? areaVal.replace(/"/g, "") : ""
  let split_and = ""

  let intro = []
  let property_text = ""
  let property_text_2 = ""

  const action = searchtypeVal ? SearchType[searchtypeVal].toLowerCase() : ""

  property_text +=
    departmentVal === "commercial" ? "commercial property" : "property"
  property_text_2 +=
    departmentVal === "commercial" ? "Commercial property" : "property"

  if (searchtypeVal === "newdevelopments") {
    property_text = "new developments"
    property_text_2 = "New developments"
  }

  if (departmentVal === "newhomes") {
    property_text = "new homes"
    property_text_2 = "new homes"
  }

  // console.log("searchtypeVal", searchtypeVal, departmentVal)

  if (furnishing) {
    if (introCopy) {
      intro.push(furnishing.replace("part-", "semi-"))
      intro.push(capitalize(property_text))
    } else {
      intro.push(capitalize(furnishing.replace("part-", "semi-")))
      intro.push(property_text)
    }
  } else if (introCopy) {
    intro.push(capitalize(property_text))
  } else {
    intro.push(property_text_2)
  }

  if (introCopy) {
    //     if (furnishing) {
    //         intro.push(furnishing)
    //     }

    //   intro.push("property");
    if (!areasVal) {
      split_and = defaultArea.split(" and ")
      // console.log("split_and =>", split_and)

      if (split_and?.length > 2) {
        areasVal = defaultArea.replace(" and", ",")
      } else {
        areasVal = defaultArea
      }
    }
  } else if (searchtypeVal === "newdevelopments") {
    intro = ["New developments"]

    if (!areasVal) {
      intro = ["New Developments"]

      split_and = defaultArea.split(" and ")
      if (split_and?.length > 2) {
        areasVal = defaultAreaNewhomes.replace(" and", ",")
      } else {
        areasVal = defaultAreaNewhomes
      }
    } else {
      intro = ["New developments"]
    }
  } else if (!areasVal) {
    split_and = defaultArea.split(" and ")

    if (split_and?.length > 2) {
      areasVal = defaultArea.replace(" and", ",")
    } else {
      areasVal = defaultArea
    }
  }

  // console.log("property_type_list intro", property_type_list)

  if (buildingval) {
    intro = []

    // console.log("filter_prop_type", filter_prop_type, filter_prop_type?.length, propertyType);

    const filterPropType =
      propertyTypeList?.length > 0 &&
      propertyTypeList.filter((item) => item.value === buildingval)

    let propType = `${buildingval.replace(/-/g, " ")}`
    if (filterPropType?.length > 0) {
      propType = filterPropType[0].label.replace(/\//g, " and ")
    } else {
      propType = `${
        buildingval.charAt(0).toUpperCase() +
        buildingval.substring(1).replaceAll("-", " ")
      }s`
    }

    if (departmentVal === "newhomes") {
      if (introCopy) {
        intro.push(`New ${propType.toLowerCase()}`)
      } else {
        intro.push(`new ${propType.toLowerCase()}`)
      }
    } else if (searchtypeVal === "newdevelopments") {
      if (introCopy) {
        intro.push(`New ${propType.toLowerCase()}`)
      } else {
        intro.push(`new ${propType.toLowerCase()}`)
      }
    } else if (introCopy) {
      intro.push(propType)
    } else {
      intro.push(propType)
    }

    //   if(property_type_list?.length > 0){
    //     property_type_list.filter(item => item.value === propertyType)
    //   }
    // intro.push(capitalize(propertyType));
  }

  if (action) {
    intro.push(action)
  }
  if (areasVal) {
    split_and = areasVal.split(" and ")
    // console.log("split_and", split_and, areas)

    let areaName = `in ${toCapitalize(areasVal)}`

    if (split_and.length >= 2) {
      areaName = `in ${areasVal}`
    } else if (areasVal.length < 5) {
      areaName = `in ${areasVal.toUpperCase()}`
    }
    intro.push(areaName)

    // intro.push(`in ${areas}`)
  }

  // if (isMetaTitle) {
  //   intro.push(`| ${capitalize(areas)} homes`)
  //   if (action) {
  //     intro.push((action))
  //   }
  // }

  // if (introCopy || isMetaTitle) {
  // return join(intro, ' ');
  // }

  // console.log("bedVal", bedVal, departmentVal)

  if (bedVal >= 0) {
    if (parseInt(bedVal, 10) === 0) {
      if (departmentVal !== "commercial") {
        intro.push("with studios")
      }
    } else if (bedValPlus === "true") {
      intro.push(`with more than ${bedVal} bedrooms`)
    } else if (parseInt(bedVal, 10) > 1) {
      intro.push(`with ${bedVal} bedrooms`)
    } else if (parseInt(bedVal, 10) === 1) {
      intro.push(`with ${bedVal} bedroom`)
    }
  }

  if (minpriceVal || maxpriceVal) {
    intro.push(getPriceStr(minpriceVal, maxpriceVal))
  }

  if (mustInclude?.length > 0) {
    let mustInclude_arr = ""

    // console.log("mustInclude_arr", mustInclude[mustInclude.length - 2]);

    mustInclude?.forEach(function (item) {
      if (item === mustInclude[mustInclude.length - 2]) {
        mustInclude_arr += `${item.replace(/-/g, " ")} and `
      } else {
        mustInclude_arr += `${item.replace(/-/g, " ")}, `
      }
    })

    intro.push(` with ${mustInclude_arr.slice(0, -2)}`)
  }

  if (radiusVal) {
    if (parseInt(radiusVal, 10) > 1) {
      intro.push(` within ${radiusVal} Miles`)
    } else {
      intro.push(` within ${radiusVal} Mile`)
    }
  }

  return join(intro, " ")
}

export const getSeoDesc = (props) => {
  const {
    searchTypeVal,
    areaVal,
    minBedVal,
    minPriceVal,
    maxPriceVal,
    buildingVal,
    radiusVal,
  } = props

  const h1Text = propertyIntro(props, false)
  const action = searchTypeVal === "sales" ? "for sale" : "to rent"
  const areas =
    areaVal !== defaultArea.toLowerCase() ? areaVal.replace(/"/g, "") : ""
  const building = buildingVal
  const bedroom = minBedVal
  const minPrice = minPriceVal ? GetPrice(minPriceVal) : ""
  const maxPrice = maxPriceVal ? GetPrice(maxPriceVal) : ""

  // console.log("minPrice", minPrice, maxPrice, minPriceVal)

  let desc = `Explore our latest collection of ${h1Text}. Contact ${siteName} in ${areas} to find the right property for you.`

  if (areas) {
    desc = `Explore our range of ${h1Text}. Contact our property experts to find the right property ${action} ${areas}.`
  }
  if (building) {
    desc = `Looking for a ${h1Text}? Property experts from ${siteName} are here to help.`
  }
  if (bedroom) {
    desc = `Explore ${h1Text} here. Contact our expert estate agents today to get assistance in finding the right property in ${areas}.`
  }
  if (radiusVal) {
    desc = `Identify the best ${h1Text}. Book an appointment with Webbers in ${areas}.`
  }
  if (minPrice || maxPrice) {
    desc = `Locate the right ${h1Text} with ${siteName}. Book an appointment with one of our property experts ${areas}.`
  }
  if ((minPrice || maxPrice) && building) {
    desc = `Check out the latest collection of ${h1Text} with ${siteName} ${areas}.`
  }
  if ((minPrice || maxPrice) && bedroom) {
    desc = `Explore the list of ${h1Text} with ${siteName} and request a viewing for the property that interests you.`
  }
  if ((minPrice || maxPrice) && radiusVal) {
    desc = `Identify the ${h1Text}. Book an viewing with Webbers in ${areas}.`
  }
  if (building && bedroom) {
    desc = `Find the latest collection of ${h1Text}. Contact ${siteName} ${areas}, to arrange a viewing.`
  }
  if (building && radiusVal) {
    desc = `Locate the best ${h1Text}. Book an appointment with ${siteName} in ${areas} to get assistance.`
  }
  if ((minPrice || maxPrice) && building && bedroom) {
    desc = `Explore ${h1Text} available with ${siteName}. Contact one of our estate agents for assistance in finding your property ${areas}.`
  }

  return desc
}
